import { render } from "./SmallExInGraySquareIcon.vue?vue&type=template&id=58edbe4e&scoped=true"
import script from "./SmallExInGraySquareIcon.vue?vue&type=script&lang=js"
export * from "./SmallExInGraySquareIcon.vue?vue&type=script&lang=js"

import "./SmallExInGraySquareIcon.vue?vue&type=style&index=0&id=58edbe4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-58edbe4e"

export default script